import React from "react"
import "./frames.css"

const Normativa = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Normativa</h1>
      <h2 className="frames-subtitle">Normativa de Aplicación</h2>
      <p className="frames-text">
        Cada territorio tiene sus propias normas definidas por las autoridades
        sanitarias locales. Sin embargo, hay normativas generales que son de
        obligado cumplimiento en cualquier lugar. Es crucial conocer estas
        normativas al desarrollar un nuevo proyecto. Te asesoramos en este
        proceso para asegurarnos de que tu instalación cumple con todos los
        estándares requeridos.
      </p>
    </div>
  )
}

export default Normativa
